import DataStoriesPage from 'components/pages/DataStoriesPage';
import { useProjectTreeStore } from 'store/projectContract.store';

export const RenderProjectDataStories = () => {
    const { project, contract } = useProjectTreeStore();
    return <DataStoriesPage project={project} contract={contract} />;
};
